<h2 mat-dialog-title class="error-title">
  <mat-icon [color]="isManualReport ? 'primary' : 'warn'">{{ isManualReport ? 'flag' : 'error_outline' }}</mat-icon>
  {{ isManualReport ? 'Report an Issue' : 'An Unexpected Error Occurred' }}
</h2>
<mat-dialog-content class="error-content">
  <p class="error-intro">
    {{
      isManualReport
        ? 'Let us know what issue you ran into and our team will look into it.'
        : "We're sorry, but something went wrong. You can help us fix this by sending a report."
    }}
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>What were you trying to do?</mat-label>
    <textarea
      matInput
      [(ngModel)]="userMessage"
      rows="4"
      placeholder="e.g. I clicked the Save button on the student form..."
    ></textarea>
  </mat-form-field>

  <mat-expansion-panel class="advanced-details" *ngIf="!isManualReport">
    <mat-expansion-panel-header>
      <mat-panel-title> View Technical Details </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="stack-trace">
      <p><strong>Error:</strong> {{ data.error?.message || data.error }}</p>
      <pre>{{ getStackTrace() }}</pre>
    </div>
  </mat-expansion-panel>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-raised-button color="primary" (click)="submitReport()" [disabled]="isSubmitting">
    <mat-icon *ngIf="!isSubmitting">send</mat-icon>
    <mat-spinner diameter="20" *ngIf="isSubmitting"></mat-spinner>
    {{ isSubmitting ? 'Sending...' : 'Send Report' }}
  </button>
</mat-dialog-actions>
